import React, { Component } from 'react';

class ProposalLineitem extends Component {
    constructor(props){
        super(props);
        this.state = {
            quantityValue:1,
            amountValue:0,
            description:''
        }
        this.changeQuantity = this.changeQuantity.bind(this);
        this.changeAmount = this.changeAmount.bind(this);
        this.changeDescription = this.changeDescription.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    changeQuantity(event){
        this.setState({quantityValue: event.target.value}, () => this.props.lineitem.quantity = this.state.quantityValue);
    }

    changeAmount(event){
        this.setState({amountValue: event.target.value}, () => this.props.lineitem.default_amount = this.state.amountValue);
    }

    changeDescription(event){
        this.setState({description: event.target.value}, () => this.props.lineitem.description = this.state.description);
    }

    handleSubmit(){
        // console.log(this.props.lineitem);
        this.props.handler(this.props.lineitem);
    }

    componentDidMount(){
        this.setState({
            amountValue:this.props.lineitem.default_amount,
            description:this.props.lineitem.description
        })
    }


  render() {
      const {lineitem} = this.props;
      if (!lineitem) return <div className="alert alert-danger">No Inquiry Loaded</div>;
      var widget = null;
      var outline = null;
      switch (lineitem.sys_calculate_type) {
            case 'QUANTITY_PLUS':
                outline = 'bt-3 border-danger';
                widget = (
                <React.Fragment>
                    <div className="form-group col-3">
                        <label>Qty</label>
                        <input className="form-control" type="number" value={this.state.quantityValue} onChange={this.changeQuantity}/>
                    </div>
                    <div className="form-group col-9">
                        <label>Amount in $ to Add</label>
                        <input className="form-control" type="number" value={this.state.amountValue} onChange={this.changeAmount}/>
                    </div>
                </React.Fragment>
                );
                break;
            case 'PERCENTAGE_PLUS':
                outline = 'bt-3 border-danger';
                widget = (
                <React.Fragment>
                    <div className="form-group col-12">
                        <label>% to add</label>
                        <input className="form-control" type="number" value={this.state.amountValue} onChange={this.changeAmount}/>
                    </div>
                </React.Fragment>
                );
                break;
            case 'DIRECT_PLUS':
                outline = 'bt-3 border-danger';
                widget = (
                <React.Fragment>
                    <div className="form-group col-12">
                        <label>Amount $ to Add</label>
                        <input className="form-control" type="number" value={this.state.amountValue} onChange={this.changeAmount}/>
                    </div>
                </React.Fragment>
                );
                break;
            case 'QUANTITY_MINUS':
                outline = 'bt-3 border-success';
                widget = (
                <React.Fragment>
                    <div className="form-group col-3">
                        <label>Qty</label>
                        <input className="form-control" type="number" value={this.state.quantityValue} onChange={this.changeQuantity}/>
                    </div>
                    <div className="form-group col-9">
                        <label>Amount in $ to Remove</label>
                        <input className="form-control" type="number" value={this.state.amountValue} onChange={this.changeAmount}/>
                    </div>
                </React.Fragment>
                );
                break;
            case 'PERCENTAGE_MINUS':
                outline = 'bt-3 border-success';
                widget = (
                <React.Fragment>
                    <div className="form-group col-12">
                        <label>% to Remove</label>
                        <input className="form-control" type="number" value={this.state.amountValue} onChange={this.changeAmount}/>
                    </div>
                </React.Fragment>
                );
                break;
            case 'DIRECT_MINUS':
                outline = 'bt-3 border-success';
                widget = (
                <React.Fragment>
                    <div className="form-group col-12">
                        <label>Amount $ to Remove</label>
                        <input className="form-control" type="number" value={this.state.amountValue} onChange={this.changeAmount}/>
                    </div>
                </React.Fragment>
                );
                break;
          default:

      }


    return (
        <div className={"card card-shadowed " + outline}>
            <header className="card-header">
                <h4 className="card-title"><strong>{lineitem.name}</strong></h4>
            </header>
            <div className="card-body">
                <div className="form-group">
                    <textarea className="form-control" value={this.state.description} onChange={this.changeDescription}></textarea>
                </div>
                <div className="form-groups-attached">
                    <div className="row">
                    {widget}
                    </div>
                </div>
            </div>
            <footer className="card-footer">
                <button className="btn btn-info btn-block" onClick={this.handleSubmit}>Add {lineitem.name}</button>
            </footer>
        </div>
    )
  }
}

export default ProposalLineitem;



// WEBPACK FOOTER //
// ./src/components/business/ProposalLineitem.js